import { LearningMaterials } from "UIPalette/LearningMaterials/LearningMaterials";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useUserContext } from "core/state/UserContext/UserContext";
import { trackCardClicks } from "core/monitoring/Events";

export const PersonalisedNewsFeed = () => {
  const { t } = useTranslation(undefined, { keyPrefix: "home.personalisedNewsFeed" });
  const { user } = useUserContext();
  const interestCategoryIds = (user?.interests ?? []).map((x) => x.categoryId);
  const useHasAnyInterests = interestCategoryIds.length > 0;

  return (
    <div>
      <h2>{t("title")}</h2>
      {useHasAnyInterests ? (
        <p className="pb-2">
          {t("learnMorePrompt")}&nbsp;
          <NavLink onClick={() => trackCardClicks(t("goToResourcesLinkText"))} to="/resources">
            {t("goToResourcesLinkText")}
          </NavLink>
        </p>
      ) : (
        <p className="pb-2">
          {t("setPreferencesPrompt")}&nbsp;
          <NavLink onClick={() => trackCardClicks(t("setPreferencesLinkText"))} to="/preferences">
            {t("setPreferencesLinkText")}
          </NavLink>
        </p>
      )}
      <LearningMaterials categoryIds={interestCategoryIds} errorMessage={t("errorButton")} ariaLabel={t("label")} />
    </div>
  );
};
